<div class='full-form' [ngClass]='stepConfig.options.formConfig.formStyle || "style-1"'>
  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
  }
  <form-viewer #formViewer
    [record]='datasetRS.record.value'
    [dataContainerService]='datasetACS'
    [formConfig]='stepConfig.options.formConfig'
    [readOnly]='!canEdit'
  ></form-viewer>

  @if (canEdit) {
    <div class="mt-24 mb-24 fx-row fx-justify-end fx-items-center" style="gap: 10px">
      <!--<button mat-raised-button>Annulla</button>-->
      <button color='accent' [disabled]='datasetACS.loading.value' mat-flat-button (click)='onSave()'>
        @if (!datasetACS.loading.value) {
          <span>{{ (hasNext ? "Salva e vai avanti" : "Salva") | translate }}</span>
        }
        @if (datasetACS.loading.value) {
          <span>{{'Azione in corso...' | translate}}</span>
        }
      </button>
    </div>
  }
</div>